import { createSlice } from "@reduxjs/toolkit";
import { getReleaseDocListAPI } from "../../services/releaseDocAPIs";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getReleaseDocsSlice = createSlice({
  name: "getReleaseDocs",
  initialState: data,
  reducers: {
    getReleaseDocsInfo(state) {
      state.isLoading = true;
    },
    getReleaseDocsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getReleaseDocsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getReleaseDocsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getReleaseDocsHandler = (data) => async (dispatch) => {
  try {
    dispatch(getReleaseDocsAction.getReleaseDocsInfo());
    const response = await getReleaseDocListAPI(data);
    dispatch(getReleaseDocsAction.getReleaseDocsInfoSuccess(response));
  } catch (e) {
    dispatch(getReleaseDocsAction.getReleaseDocsInfoFailure(e));
  }
};
export default getReleaseDocsSlice.reducer;
export const getReleaseDocsAction = getReleaseDocsSlice.actions;
